import * as FileSaver from "file-saver";
import { SerProGateway } from "../gateway/SerproGateway/SerproGateway";

/**
 * Baixa o PDF de uma declaração do PGDAS. O back devolve o arquivo que o Serpro entregou, em
 * base64; aqui ele vira o PDF que o contador salva. Devolve `false` quando não há PDF e
 * lança quando o download falha (rede, arquivo corrompido).
 */
export class DownloadSerproDeclarationPdfUsecase {
    constructor() {
        this.SerProGateway = new SerProGateway();
    }

    async execute({ accountingId = "", declarationId = "" } = {}) {
        const payload = this.sanitizeInput({ accountingId, declarationId });
        if (!payload.accountingId || !payload.declarationId) return false;

        try {
            const pdf = await this.SerProGateway.getDeclarationPdf(payload);
            if (!pdf) return false;

            FileSaver.saveAs(this.toBlob(pdf.contentBase64), pdf.fileName || "PGDAS-D.pdf");
            return true;
        } catch (error) {
            throw new Error(error.message || "Não foi possível baixar o PDF da declaração");
        }
    }

    toBlob(contentBase64) {
        const binary = atob(contentBase64);
        const bytes = new Uint8Array(binary.length);
        for (let index = 0; index < binary.length; index++) {
            bytes[index] = binary.charCodeAt(index);
        }
        return new Blob([bytes], { type: "application/pdf" });
    }

    sanitizeInput({ accountingId = "", declarationId = "" } = {}) {
        return {
            accountingId: String(accountingId).trim(),
            declarationId: String(declarationId).trim()
        };
    }
}
